import * as DTO from "../../../../../interfaces";
import { Button, Modal } from "semantic-ui-react";
import { EditableField } from "../../../../Inputs";
import React from "react";
import { validateLong } from "../../../../../utils";
import { CategoriesServices } from "../../../../../services";
import { CampaignCard } from "../../../../Cells";
import "./styles.scss";

interface OwnProps {
  open: boolean;
  onClose: () => void;
  coachId: string;
  category?: DTO.Category;
  campaigns: DTO.CampaignResume[];
  canEdit: boolean;
  onUpdate: (category: DTO.Category) => void;
}

type Props = OwnProps;

export const CampaignCategoryModal: React.FC<Props> = ({
  open,
  onClose,
  coachId,
  category,
  campaigns,
  canEdit,
  onUpdate,
}) => {
  const changeCategoryName = (category: DTO.Category, newValue: string) => {
    const newCatName = newValue ? newValue.trim() : newValue;
    if (newValue && validateLong(2, 25, newValue)) {
      CategoriesServices.update(coachId, { ...category, name: newCatName })
        .then(newCategory => {
          onUpdate(newCategory);
        })
        .catch(e => {
          if (e.status === 409) {
            alert("You already have a category named: " + newCatName);
          } else {
            alert(e.message);
          }
        });
    } else {
      alert("Category name should have 2-25 characters.");
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={"campaignCategoryModal"}
      size={campaigns.length > 15 ? "fullscreen" : "large"}
    >
      {category && (
        <>
          <Modal.Header>
            <EditableField
              headerType={"h3"}
              name={"libraryCategoryId" + category.name}
              currentValue={category.name}
              handleChangeValue={value => changeCategoryName(category, value)}
              disable={!canEdit}
            />
          </Modal.Header>
          <Modal.Content className={"cardGridContent"}>
            <div className={"cardGrid"}>
              {campaigns.map(campaign => {
                return <CampaignCard key={`selected-campaign-card-${campaign.campaignId}`} campaign={campaign} />;
              })}
            </div>
          </Modal.Content>
        </>
      )}
      <Modal.Actions>
        <Button onClick={onClose} className={"rounded"} secondary>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
